export default {
  TableHead: [
    [
      {
        displayName: 'webManagement.no',
      },
      {
        displayName: 'webManagement.image',
      },
      {
        displayName: 'webManagement.description',
      },
      {
        displayName: 'webManagement.status',
      },
      {
        displayName: 'webManagement.sort',
      },
      {
        displayName: 'webManagement.edit',
      },
      {
        displayName: 'webManagement.delete',
      },
    ],
  ],
};
